import React from "react";
import { Card, SkeletonLoader, Text } from "@merge-api/merge-javascript-shared";
import { LinkedAccountMetrics } from "../../../../../models/Entities";

interface Props {
  metrics?: LinkedAccountMetrics;
  loading: boolean;
  permissionDenied?: boolean;
}

const COUNTS: { label: string; key: keyof LinkedAccountMetrics }[] = [
  { label: "Linked", key: "completed_linked_accounts_count" },
  { label: "Relink", key: "relink_needed_accounts_count" },
  { label: "Incomplete", key: "incomplete_linked_accounts_count" },
  { label: "Idle", key: "idle_accounts_count" },
];

const LinkedAccountsSummary = ({ metrics, loading, permissionDenied }: Props) => (
  <Card className="mb-4">
    <div className="grid grid-cols-4 divide-x divide-gray-10" aria-label="Linked Account totals">
      {COUNTS.map(({ label, key }) => (
        <div key={key} className="flex flex-col p-3 text-gray-80">
          <Text variant="h6" as="span">
            {label}
          </Text>
          {permissionDenied ? (
            <Text>—</Text>
          ) : loading ? (
            <SkeletonLoader height={24} fullWidth borderRadius={4} />
          ) : (
            <Text>{metrics?.[key] ?? "–"}</Text>
          )}
        </div>
      ))}
    </div>
  </Card>
);

export default LinkedAccountsSummary;
